(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-palate-quiz"] && !Shopify.designMode) return;
  try {
    
const CAPSULES = [
  {
    id: 0,
    name: "Bone Dry",
    handle: "bone-dry",
    colour: "#D8D5CF",
    description: "Crisp minerality and pristine acidity. For those who crave structure.",
    idealProfile: { bitterness: 4, acidity: 4, sweetness: 0, body: 1, earthiness: 1, adventure: 1 }
  },
  {
    id: 1,
    name: "Crisp & Citrus",
    handle: "crisp-citrus",
    colour: "#8FA84A",
    description: "Bright, tart, and refreshingly grounded. Clean and energizing.",
    idealProfile: { bitterness: 2, acidity: 4, sweetness: 0, body: 1, earthiness: 1, adventure: 2 }
  },
  {
    id: 2,
    name: "Floral & Lifted",
    handle: "floral-lifted",
    colour: "#C9B7E3",
    description: "Aromatic and delicate with gentle sweetness. Ethereal and elegant.",
    idealProfile: { bitterness: 1, acidity: 1, sweetness: 3, body: 1, earthiness: 0, adventure: 2 }
  },
  {
    id: 3,
    name: "Tropical & Vibrant",
    handle: "tropical-vibrant",
    colour: "#FF9F45",
    description: "Zesty, juicy, and sun-drenched. Pure pleasure and vibrancy.",
    idealProfile: { bitterness: 0, acidity: 3, sweetness: 2, body: 2, earthiness: 0, adventure: 3 }
  },
  {
    id: 4,
    name: "Round & Generous",
    handle: "round-generous",
    colour: "#E7C27D",
    description: "Balanced and approachable. Rich without being heavy.",
    idealProfile: { bitterness: 1, acidity: 1, sweetness: 2, body: 3, earthiness: 1, adventure: 1 }
  },
  {
    id: 5,
    name: "Amber & Structured",
    handle: "amber-structured",
    colour: "#C66A2B",
    description: "Oxidative complexity with earthy depth. Sophisticated and layered.",
    idealProfile: { bitterness: 2, acidity: 2, sweetness: 1, body: 3, earthiness: 4, adventure: 3 }
  },
  {
    id: 6,
    name: "Light & Juicy",
    handle: "light-juicy",
    colour: "#D64C64",
    description: "Bright fruit forward and refreshingly low pressure. Easy joy.",
    idealProfile: { bitterness: 0, acidity: 2, sweetness: 3, body: 1, earthiness: 0, adventure: 2 }
  },
  {
    id: 7,
    name: "Silky & Elegant",
    handle: "silky-elegant",
    colour: "#8E2F4F",
    description: "Smooth tannins with refined complexity. Effortlessly sophisticated.",
    idealProfile: { bitterness: 2, acidity: 1, sweetness: 1, body: 3, earthiness: 1, adventure: 1 }
  },
  {
    id: 8,
    name: "Spicy & Savoury",
    handle: "spicy-savoury",
    colour: "#5C3A2E",
    description: "Earthy, textured, and deeply aromatic. Bold and distinctive.",
    idealProfile: { bitterness: 2, acidity: 1, sweetness: 0, body: 4, earthiness: 4, adventure: 2 }
  },
  {
    id: 9,
    name: "Bold & Structured",
    handle: "bold-structured",
    colour: "#4A0F1B",
    description: "Powerful tannins and intense flavour. For serious palates.",
    idealProfile: { bitterness: 4, acidity: 2, sweetness: 0, body: 4, earthiness: 2, adventure: 2 }
  },
  {
    id: 10,
    name: "Oxidative & Complex",
    handle: "oxidative-complex",
    colour: "#8A6A4F",
    description: "Layered, adventurous, and deeply interesting. A journey in a glass.",
    idealProfile: { bitterness: 2, acidity: 1, sweetness: 1, body: 3, earthiness: 4, adventure: 4 }
  },
  {
    id: 11,
    name: "Lush & Sweet",
    handle: "lush-sweet",
    colour: "#C9A227",
    description: "Indulgent and fruit-forward. Pure sensory pleasure.",
    idealProfile: { bitterness: 0, acidity: 0, sweetness: 4, body: 2, earthiness: 0, adventure: 1 }
  }
];

const QUESTIONS = [
  {
    id: 0,
    question: "How do you take your coffee?",
    answers: [
      { text: "Black, no sugar", scores: { bitterness: 4, sweetness: 0, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "Black with sugar", scores: { bitterness: 3, sweetness: 1, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "Splash of milk", scores: { bitterness: 2, sweetness: 1, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "Milky latte", scores: { bitterness: 1, sweetness: 2, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "I don't drink coffee", scores: { bitterness: 0, sweetness: 3, acidity: 0, body: 0, earthiness: 0, adventure: 0 } }
    ]
  },
  {
    id: 1,
    question: "Pick your chocolate",
    answers: [
      { text: "90% dark", scores: { bitterness: 4, sweetness: 0, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "70% dark", scores: { bitterness: 2, sweetness: 1, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "Milk chocolate", scores: { bitterness: 1, sweetness: 3, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "White chocolate", scores: { bitterness: 0, sweetness: 4, acidity: 0, body: 0, earthiness: 0, adventure: 0 } }
    ]
  },
  {
    id: 2,
    question: "Citrus preference?",
    answers: [
      { text: "Grapefruit — bitter & sharp", scores: { bitterness: 2, sweetness: 0, acidity: 4, body: 0, earthiness: 0, adventure: 0 } },
      { text: "Lemon — tart & clean", scores: { bitterness: 1, sweetness: 0, acidity: 3, body: 0, earthiness: 0, adventure: 0 } },
      { text: "Orange — sweet & juicy", scores: { bitterness: 0, sweetness: 2, acidity: 1, body: 0, earthiness: 0, adventure: 0 } },
      { text: "Not a fan", scores: { bitterness: 0, sweetness: 1, acidity: 0, body: 0, earthiness: 0, adventure: 0 } }
    ]
  },
  {
    id: 3,
    question: "Your ideal dessert?",
    answers: [
      { text: "Cheese board", scores: { bitterness: 0, sweetness: 0, acidity: 0, body: 3, earthiness: 0, adventure: 0 } },
      { text: "Dark chocolate torte", scores: { bitterness: 2, sweetness: 0, acidity: 0, body: 2, earthiness: 0, adventure: 0 } },
      { text: "Crème brûlée", scores: { bitterness: 0, sweetness: 2, acidity: 0, body: 2, earthiness: 0, adventure: 0 } },
      { text: "Sticky toffee pudding", scores: { bitterness: 0, sweetness: 4, acidity: 0, body: 1, earthiness: 0, adventure: 0 } }
    ]
  },
  {
    id: 4,
    question: "Mushrooms or berries?",
    answers: [
      { text: "Wild mushrooms on toast", scores: { bitterness: 0, sweetness: 0, acidity: 0, body: 2, earthiness: 4, adventure: 0 } },
      { text: "Forest berry compote", scores: { bitterness: 0, sweetness: 2, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "A bit of both", scores: { bitterness: 0, sweetness: 1, acidity: 0, body: 0, earthiness: 2, adventure: 0 } },
      { text: "Neither", scores: { bitterness: 0, sweetness: 1, acidity: 0, body: 0, earthiness: 1, adventure: 0 } }
    ]
  },
  {
    id: 5,
    question: "How adventurous are you?",
    answers: [
      { text: "I know what I like", scores: { bitterness: 0, sweetness: 0, acidity: 0, body: 0, earthiness: 0, adventure: 0 } },
      { text: "Open to suggestions", scores: { bitterness: 0, sweetness: 0, acidity: 0, body: 0, earthiness: 0, adventure: 1 } },
      { text: "Surprise me always", scores: { bitterness: 0, sweetness: 0, acidity: 0, body: 0, earthiness: 0, adventure: 3 } },
      { text: "The weirder the better", scores: { bitterness: 0, sweetness: 0, acidity: 0, body: 0, earthiness: 0, adventure: 4 } }
    ]
  }
];

class PalateQuiz {
  constructor(containerSelector) {
    this.container = document.querySelector(containerSelector);
    this.currentQuestion = 0;
    this.scores = { bitterness: 0, sweetness: 0, acidity: 0, body: 0, earthiness: 0, adventure: 0 };
    this.selectedAnswers = [];
    this.resultCapsules = [];
    this.init();
  }

  init() {
    this.render();
    this.attachEventListeners();
  }

  render() {
    if (this.currentQuestion < QUESTIONS.length) {
      this.renderQuestion();
    } else {
      this.calculateResults();
      this.renderResults();
    }
  }

  renderQuestion() {
    const question = QUESTIONS[this.currentQuestion];
    const progressPercent = ((this.currentQuestion) / QUESTIONS.length) * 100;

    let html = `
      <div class="quiz-container quiz-active">
        <div class="quiz-progress-bar">
          <div class="quiz-progress-fill" style="width: ${progressPercent}%"></div>
        </div>

        <div class="quiz-counter">Question ${this.currentQuestion + 1} of ${QUESTIONS.length}</div>

        <h2 class="quiz-question">${question.question}</h2>

        <div class="quiz-answers">
    `;

    question.answers.forEach((answer, index) => {
      html += `
        <button class="quiz-answer-card" data-answer-index="${index}">
          <span class="quiz-answer-text">${answer.text}</span>
        </button>
      `;
    });

    html += `
        </div>

        ${this.currentQuestion > 0 ? `<button class="quiz-back-button">← Back</button>` : ''}
      </div>
    `;

    this.container.innerHTML = html;
  }

  renderResults() {
    const primary = this.resultCapsules[0];
    const adjacent1 = this.resultCapsules[1];
    const adjacent2 = this.resultCapsules[2];

    let html = `
      <div class="quiz-container quiz-results-active">
        <div class="quiz-results-header">
          <h2 class="quiz-results-title">Your Palate Profile</h2>
        </div>

        <div class="quiz-primary-capsule">
          <div class="quiz-capsule-circle" style="background-color: ${primary.colour}"></div>
          <h3 class="quiz-capsule-name">${primary.name}</h3>
          <p class="quiz-capsule-description">${primary.description}</p>
        </div>

        <div class="quiz-adjacent-label">You'll also love</div>

        <div class="quiz-adjacent-capsules">
          <div class="quiz-adjacent-card" style="border-color: ${adjacent1.colour}">
            <div class="quiz-adjacent-circle" style="background-color: ${adjacent1.colour}"></div>
            <p class="quiz-adjacent-name">${adjacent1.name}</p>
          </div>
          <div class="quiz-adjacent-card" style="border-color: ${adjacent2.colour}">
            <div class="quiz-adjacent-circle" style="background-color: ${adjacent2.colour}"></div>
            <p class="quiz-adjacent-name">${adjacent2.name}</p>
          </div>
        </div>

        <div class="quiz-ctas">
          <a href="/collections/${primary.handle}" class="quiz-cta-button quiz-cta-primary">Shop Your Capsule</a>
          <a href="/pages/subscribe" class="quiz-cta-button quiz-cta-secondary">Subscribe</a>
        </div>

        <button class="quiz-retake-link">← Retake Quiz</button>

        <div class="quiz-attribution">
          Based on Tim Hanni MW's Vinotype methodology · Validated by Michigan State University, 2017
        </div>
      </div>
    `;

    this.container.innerHTML = html;
    this.attachResultsListeners();
  }

  calculateResults() {
    const distances = CAPSULES.map(capsule => {
      let distance = 0;
      for (const dimension in this.scores) {
        const scoreDiff = this.scores[dimension] - capsule.idealProfile[dimension];
        distance += scoreDiff * scoreDiff;
      }
      return { capsule, distance: Math.sqrt(distance) };
    });

    distances.sort((a, b) => a.distance - b.distance);
    this.resultCapsules = distances.slice(0, 3).map(item => item.capsule);
  }

  attachEventListeners() {
    const answerCards = this.container.querySelectorAll('.quiz-answer-card');
    answerCards.forEach(card => {
      card.addEventListener('click', (e) => this.handleAnswer(e));
    });

    const backButton = this.container.querySelector('.quiz-back-button');
    if (backButton) {
      backButton.addEventListener('click', () => this.goBack());
    }
  }

  attachResultsListeners() {
    const retakeButton = this.container.querySelector('.quiz-retake-link');
    if (retakeButton) {
      retakeButton.addEventListener('click', () => this.reset());
    }
  }

  handleAnswer(event) {
    const card = event.currentTarget;
    const answerIndex = parseInt(card.dataset.answerIndex);
    const answer = QUESTIONS[this.currentQuestion].answers[answerIndex];

    for (const dimension in answer.scores) {
      this.scores[dimension] += answer.scores[dimension];
    }

    this.selectedAnswers.push(answerIndex);
    card.classList.add('quiz-answer-selected');

    setTimeout(() => {
      this.currentQuestion++;
      this.render();
    }, 400);
  }

  goBack() {
    if (this.currentQuestion > 0) {
      this.currentQuestion--;
      const lastAnswer = this.selectedAnswers.pop();
      const previousQuestion = QUESTIONS[this.currentQuestion];

      for (const dimension in previousQuestion.answers[lastAnswer].scores) {
        this.scores[dimension] -= previousQuestion.answers[lastAnswer].scores[dimension];
      }

      this.render();
    }
  }

  reset() {
    this.currentQuestion = 0;
    this.scores = { bitterness: 0, sweetness: 0, acidity: 0, body: 0, earthiness: 0, adventure: 0 };
    this.selectedAnswers = [];
    this.resultCapsules = [];
    this.render();
  }
}

window.PalateQuiz = PalateQuiz;

  } catch(e) { console.error(e); }
})();
})();
